import { createSelector } from 'reselect';
import { getAccounts } from 'state/account/AccountSelectors';
import {
  applyPerformanceFilters,
  createTimeRangeFromFilter,
  modifyDateRange
} from './PerformancePageUtils';
import {
  getInceptionDateForFilterType,
  PORTFOLIO_GROWTH_FILTER_TYPE
} from './PerformancePageSelectors';
import { getPortfolioAsOfDate } from 'state/portfolio/PortfolioSelectors';
import {doesObjectPropertyNotHaveValue} from 'services/Formats';

export const getPortfolioGrowthFilter = (state) => state.portfolioGrowth;
const getPerformancePage = (state) => state.performancePage;

export const getAccountsForPortfolioGrowth = createSelector(
  getPerformancePage,
  getPortfolioGrowthFilter,
  getAccounts,
  (performancePage, portfolioGrowthFilter, accounts) => {
    const filterData = applyPerformanceFilters(
      performancePage,
      portfolioGrowthFilter,
      accounts
    );
    return filterData;
  }
);

export const getInceptionDateForPortfolioGrowth = createSelector(
  [
    (state) =>
      getInceptionDateForFilterType(state, PORTFOLIO_GROWTH_FILTER_TYPE)
  ],
  (inceptionDate) => inceptionDate
);

export const getDateRangeFilterForPortfolioGrowth = createSelector(
  getPortfolioGrowthFilter,
  (portfolioGrowthFilter) => portfolioGrowthFilter.dateRangeFilter
);

export const getDateRangeForPortfolioGrowth = createSelector(
  getInceptionDateForPortfolioGrowth,
  getDateRangeFilterForPortfolioGrowth,
  getPortfolioAsOfDate,
  (inceptionDate, dateRangeFilter, portfolioAsOfDate) =>
    createTimeRangeFromFilter(inceptionDate, dateRangeFilter, portfolioAsOfDate)
);

export const getFormattedDateRangeForPortfolioGrowth = createSelector(
  getDateRangeForPortfolioGrowth,
  getPortfolioAsOfDate,
  (dateRange, portfolioAsOfDate) =>
    modifyDateRange(dateRange, portfolioAsOfDate)
);

export const getPortfolioGrowthFilterIsNull = createSelector(
  getPortfolioGrowthFilter,
  (portfolioGrowthFilter) => doesObjectPropertyNotHaveValue(portfolioGrowthFilter.dateRangeFilter) && portfolioGrowthFilter.dateRangeFilter.custom === true
);